export default __webpack_public_path__ + "static/media/btn_menu.b32db209.svg";